const MIME_TO_EXT = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/webp': 'webp',
};

function asObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function normalizeMime(raw) {
  const s = String(raw ?? '').trim().toLowerCase();
  if (MIME_TO_EXT[s]) return s;
  if (s === 'image/jpg') return 'image/jpeg';
  return 'image/jpeg';
}

/** @returns {{ base64: string, mimeType: string }|null} */
export function readNoticiaImagenBase64FromMetadata(metadata) {
  const base = asObject(metadata);
  const imagen = asObject(base.imagen);

  const raw =
    base.imagen_base64 ??
    base.imagenBase64 ??
    imagen.imagen_base64 ??
    imagen.imagenBase64 ??
    imagen.base64;

  if (raw == null) return null;

  let s = String(raw).trim();
  if (!s) return null;

  let mimeType = normalizeMime(
    base.imagen_mime ??
      base.imagenMime ??
      base.imagen_content_type ??
      imagen.imagen_mime ??
      imagen.mime ??
      imagen.content_type
  );

  const dataMatch = s.match(/^data:([^;]+);base64,(.+)$/i);
  if (dataMatch) {
    mimeType = normalizeMime(dataMatch[1]);
    s = dataMatch[2];
  }

  const base64 = s.replace(/\s/g, '');
  if (!base64) return null;

  return { base64, mimeType };
}

export function buildNoticiaImagenDataUri(base64, mimeType) {
  return `data:${normalizeMime(mimeType)};base64,${String(base64).replace(/\s/g, '')}`;
}

/** URL pública o data URI para preview admin (borrador con base64 n8n). */
export function resolveNoticiaImagenPreviewUrl(row) {
  const url = String(row?.imagen_url ?? '').trim();
  if (url) return url;
  const parsed = readNoticiaImagenBase64FromMetadata(row?.metadata);
  if (!parsed) return '';
  return buildNoticiaImagenDataUri(parsed.base64, parsed.mimeType);
}

export function noticiaTieneImagenPreview(row) {
  return !!resolveNoticiaImagenPreviewUrl(row);
}
